"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeWidgets_en_us = void 0;
function backofficeWidgets_en_us() {
    return {
        "backoffice.widgets.add": "Add Widget",
        "backoffice.widgets.notes": "Notes",
        "backoffice.widgets.users": "Users",
        "backoffice.widgets.configuration.widget": "Widget Configuration",
        "backoffice.widgets.configuration.more": "More settings",
        "backoffice.widgets.configuration.visual": "View",
        "backoffice.widgets.configuration.actions": "Actions",
        "backoffice.widgets.configuration.actionsdescription": "A Url can be used to redirect to another page.",
        "backoffice.widgets.todo.opentasks": "Open Tasks",
        "backoffice.widgets.todo.completedtasks": "Completed Tasks",
        "backoffice.widgets.todo.addnewtask": "Add new task...",
        "backoffice.widgets.todo.notaskscreated": "No tasks have been created yet.",
        "backoffice.widgets.immoscout24.nogroup": "No group is configured.",
        "backoffice.widgets.immoscout24.error": "Currently, no listings can be shown.",
        "backoffice.widgets.immoscout24.nolistings": "There are currently no listings available.",
        "backoffice.widgets.immoscout24.hearmore": "Learn more",
        "backoffice.widgets.immoscout24.price": "Price",
        "backoffice.widgets.immoscout24.rooms": "Rooms",
        "backoffice.widgets.immoscout24.livingspace": "Area",
        "backoffice.widgets.immoscout24.missingconfig": "Configuration could not be found",
        "backoffice.widgets.tags.dashboard.label": "Dashboard",
        "backoffice.widgets.tags.company-dashboard.label": "Company Dashboard",
        "backoffice.widgets.tags.project-dashboard.label": "Project Dashboard",
        "backoffice.widgets.tags.cms.label": "Project Dashboard",
        "backoffice.widgets.tags.application.label": "Applications",
        "backoffice.widgets.tags.personal-dashboard.label": "Personal Dashboard",
        "backoffice.widgets.tags.cbo.label": "Custom Backoffices",
        "backoffice.widgets.tags.container.label": "Container",
        "backoffice.widgets.tags.icon.label": "Small Icon"
    };
}
exports.backofficeWidgets_en_us = backofficeWidgets_en_us;
